import { minutosParaEmpezar } from '@/lib/meets'

import type { ItemCalendario } from '@/core/types/calendario'

/** El item del calendario ya trae la fecha de la ocurrencia resuelta en `fecha` (ORR-383). */
export const comoEvento = (item: ItemCalendario) => ({
  fecha_inicio: item.fecha,
  fecha_fin: item.fecha_fin,
  todo_el_dia: item.todo_el_dia,
})

/**
 * El título del aviso dice cuánto falta, no "hoy": es lo que permite decidir si hay que cortar
 * lo que se está haciendo o todavía hay margen.
 */
export const tituloAviso = (pendientes: ItemCalendario[], ahora: Date): string => {
  // El mínimo, no el primero de la lista: con varias, lo que importa es la más próxima.
  const faltan = Math.min(...pendientes.map((p) => minutosParaEmpezar(comoEvento(p), ahora)))

  if (pendientes.length > 1) {
    return faltan === 0
      ? `Tenés ${pendientes.length} reuniones ahora`
      : `Tenés ${pendientes.length} reuniones, la primera en ${faltan} min`
  }

  if (faltan === 0) return 'Tu reunión ya empezó'
  if (faltan === 1) return 'Tu reunión empieza en 1 minuto'
  return `Tu reunión empieza en ${faltan} minutos`
}
